<template>
  <div>
    <v-dialog :value="value" persistent max-width="800">
      <v-card>
        <v-card-title>
          กรุณาเลือกหน่วยงานที่ต้องการตรวจสอบข้อมูล
          <v-spacer />
          <v-btn icon @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            solo
            v-model="search"
            hide-details=""
            append-icon="search"
            style="max-width: 300px"
            label="ค้าหาชื่อหน่วยงาน"
          />

          <div class="text-center my-4" v-if="loading">
            <v-progress-circular color="primary" />
          </div>
          <template v-else>
            <template v-for="(division, index) in filterDivisions">
              <v-layout :key="division.id" class="my-3">
                <v-flex class="pa-2">
                  <strong class="pa-2">{{ division.groupname }}</strong>
                  <template v-if="currentDivision && currentDivision.id == division.id">
                    {{ division.groupdescription }}
                  </template>
                </v-flex>
                <v-flex shrink v-if="division.groupdescription">
                  <v-btn icon @click="handleSelectDivision(division)">
                    <v-icon>
                      {{
                        currentDivision && currentDivision.id == division.id
                          ? 'keyboard_arrow_down'
                          : 'keyboard_arrow_up'
                      }}
                    </v-icon>
                  </v-btn>
                </v-flex>
                <v-flex shrink class="px-2">
                  <v-btn color="#d80000" dark @click="handleSendDivision(division)">เลือก</v-btn>
                </v-flex>
              </v-layout>
              <v-divider
                :key="`divider_${division.id}`"
                v-if="index != filterDivisions.length - 1"
              />
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
      divisions: [],
      search: '',
      loading: true,
      currentDivision: null
    }
  },
  computed: {
    filterDivisions() {
      if (this.search && this.search.trim() != '') {
        return this.divisions.filter(division => {
          return division.groupname.toLowerCase().includes(this.search.trim().toLowerCase())
        })
      }
      return this.divisions
    }
  },
  async mounted() {
    this.loading = true
    if (!this.divisions || this.divisions.length == 0) {
      const divisions = await this.handleGetDivision()
      if (divisions) {
        this.divisions = divisions
      }
    }
    this.loading = false
  },
  methods: {
    handleSelectDivision(division) {
      if (!this.currentDivision || this.currentDivision.id != division.id) {
        this.currentDivision = division
      } else {
        this.currentDivision = null
      }
    },
    async handleGetDivision() {
      try {
        const response = await axios.get('https://communitybotbyzwizai.herokuapp.com/admingroup', {
          params: {
            pageid: process.env.VUE_APP_PAGE_ID
          }
        })
        if (response.data.responsecode == 200) {
          return response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleSendDivision(division) {
      this.$emit('sendMessage', {
        title: division.groupname,
        payload: division.groupname
      })
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
